import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { Typography, TextField, Button } from '@mui/material';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import TituloPagina2 from "conten/components/TituloPagina2";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { MobileScreenShare } from "@material-ui/icons";
import { addMessage } from "conten/mensajes/MessagesActions";
import { connect } from "react-redux";
import RegistroDispositivosApiHelper from "./InventarioDispositivosApiHelper";
import { ExportSheet } from 'react-xlsx-sheet';
import { whiteColor } from "assets/jss/material-dashboard-pro-react";
import * as XLSX from 'xlsx';
import { PERFIL_ADMINISTRADOR } from "config/general/Configuracion";

const DispositivosPermitidos = ({ classes, addMessage }) => {
  const [dispositivos, setDispositivos] = useState([]);
  const perfilActual = sessionStorage.getItem('idPerfil');
  const esAdministrador = perfilActual === PERFIL_ADMINISTRADOR;

  const listarDispositivos = async () => {
    try {
      const response = await RegistroDispositivosApiHelper.listarDispositivosRegistrados();
      setDispositivos(response || []);
    } catch (error) {
      console.error("Error al listar dispositivos permitidos:", error);
      addMessage({
        variant: "danger",
        message: `Error al listar dispositivos permitidos: ${error.message}`,
      });
    }
  };

  const guardarDispositivo = async (dispositivo) => {
    try {
      await RegistroDispositivosApiHelper.actualizarDispositivosRegistrados(dispositivo);
      listarDispositivos();
      addMessage({
        variant: "success",
        message: `Dispositivo guardado correctamente.`,
      });
    } catch (error) {
      console.error("Error al guardar dispositivo:", error);
      addMessage({
        variant: "danger",
        message: `Error al guardar dispositivo: ${error.message}`,
      });
    }
  };

  const handleEditar = (index, field, value) => {
    const actualizados = [...dispositivos];
    actualizados[index][field] = value;
    setDispositivos(actualizados);
  };

  const getColumnasXLS = () => [
    { title: 'ID', dataIndex: 'id_dispositivo' },
    { title: 'Nombre Dispositivo', dataIndex: 'nombre_dispositivo' },
    { title: 'Modelo', dataIndex: 'modelo' },
    { title: 'Número Serial', dataIndex: 'numero_serial' },
    { title: 'IMEI 1', dataIndex: 'imei1' },
    { title: 'IMEI 2', dataIndex: 'imei2' },
    { title: 'Línea Celular', dataIndex: 'linea_celular' },
    { title: 'Clave Dispositivo', dataIndex: 'clave_dispositivo' },
  ];

  useEffect(() => {
    listarDispositivos();
  }, []);

  return (
    <GridItem xs={12}>
      <Card>
        <CardHeader icon>
          <CardIcon color='info'>
            <ExportSheet
              header={getColumnasXLS()}
              fileName={`Dispositivos`}
              dataSource={dispositivos}
              xlsx={XLSX}
            >
              <button
                style={{
                  cursor: 'pointer',
                  backgroundColor: "transparent",
                  color: whiteColor,
                  border: '0px',
                }}
              >
                <b>+ Descargar</b>
              </button>
            </ExportSheet>
            <MobileScreenShare />
          </CardIcon>
          <TituloPagina2
            texto='Lista de dispositivos registrados'
            color='info'
            classes={classes}
          />
        </CardHeader>
        <CardBody>
          {dispositivos.length === 0 ? (
            <Typography>No hay dispositivos registrados.</Typography>
          ) : (
            <Paper elevation={1}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>id</strong></TableCell>
                    <TableCell><strong>Nombre dispositivo</strong></TableCell>
                    <TableCell><strong>Modelo</strong></TableCell>
                    <TableCell><strong>Número serial</strong></TableCell>
                    <TableCell><strong>Imei 1</strong></TableCell>
                    <TableCell><strong>Imei 2</strong></TableCell>
                    <TableCell><strong>Línea celular</strong></TableCell>
                    <TableCell><strong>Clave dispositivo</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dispositivos.map((d, index) => (
                    <TableRow key={d.id_dispositivo}>
                      <TableCell>{d.id_dispositivo}</TableCell>
                      <TableCell>
                        <TextField
                          value={d.nombre_dispositivo}
                          size="small"
                          type="text"
                          disabled={!esAdministrador}
                          onChange={(e) => handleEditar(index, 'nombre_dispositivo', e.target.value)}
                          onBlur={() => guardarDispositivo(dispositivos[index])}
                        />
                      </TableCell>
                      <TableCell>{d.modelo}</TableCell>
                      <TableCell>
                        <TextField
                          value={d.numero_serial}
                          size="small"
                          type="text"
                          disabled={!esAdministrador}
                          onChange={(e) => handleEditar(index, 'numero_serial', e.target.value)}
                          onBlur={() => guardarDispositivo(dispositivos[index])}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={d.imei1}
                          size="small"
                          type="number"
                          disabled={!esAdministrador}
                          onChange={(e) => handleEditar(index, 'imei1', e.target.value)}
                          onBlur={() => guardarDispositivo(dispositivos[index])}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={d.imei2}
                          size="small"
                          type="number"
                          disabled={!esAdministrador}
                          onChange={(e) => handleEditar(index, 'imei2', e.target.value)}
                          onBlur={() => guardarDispositivo(dispositivos[index])}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={d.linea_celular}
                          size="small"
                          type="number"
                          disabled={!esAdministrador}
                          onChange={(e) => {
                            const valor = parseInt(e.target.value, 10);
                            handleEditar(index, 'linea_celular', isNaN(valor) ? null : valor);
                          }}
                          onBlur={() => guardarDispositivo(dispositivos[index])}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={d.clave_dispositivo}
                          size="small"
                          type="text"
                          disabled={!esAdministrador}
                          onChange={(e) => handleEditar(index, 'clave_dispositivo', e.target.value)}
                          onBlur={() => guardarDispositivo(dispositivos[index])}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          )}
        </CardBody>
      </Card>
    </GridItem>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addMessage: (content) => dispatch(addMessage(content)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    null,
    mapDispatchToProps
  )(DispositivosPermitidos)
);
